import { fromJS } from 'immutable';

export const initialState = fromJS({
    facilities: [],
    facilitiesInMapBounds: [],
    selectedFacility: undefined,
    isListView: false
});
